<template>
  <div class="seeContract">
    <van-sticky>
      <div
        class="seeContractNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">查看合同</span>
        <img
          class="navRight"
          @click="copy()"
          id="copy"
          src="./../../../assets/decoration/order/copy.png"
        />
      </div>
    </van-sticky>
    <div class="contentBox">
      <div id="contidract" :style="contidractStyle" ref="contidract">
        <div :style="pdfStyle" ref="pdfbox">
          <pdf
            v-for="i in numPages"
            :key="i"
            :src="pdfSrc"
            :page="i"
            ref="pdfs"
            @loaded="pdfLoaded(i)"
            :style="{ width: '100%' }"
          >
          </pdf>
        </div>
      </div>
    </div>
    <div class="contractTip" v-if="isShowTip">
      甲乙双方签章在合同签订成功后生成
    </div>
  </div>
</template>
<script>
import pdf from "vue-pdf";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      isiOSX: false,
      pdfStyle: { "transform-origin": "left top" },
      contidractStyle: { "background-color": "#E3E3E3", height: "100%" },
      numPages: undefined,
      pdfSrc: "",
      data: {},
      pdf_file_url: "",
      order_status: 5,
      isShowTip: false,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    setTimeout(() => {
      this.onLoad();
    }, 200);
  },
  mounted() {
    if (this.$route.query.order_status) {
      this.order_status = this.$route.query.order_status;
      if (this.order_status == 5) {
        setTimeout(() => {
          this.isShowTip = true;
        }, 1000);
      }
    }
  },
  components: {
    pdf,
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onLoad() {
      this.$api
        .post("decoration/member/order/contract/info", {
          contract_id: this.$route.query.contract_id,
        })
        .then((res) => {
          this.data = res;
          if (res.sign_file_url && this.order_status == 8) {
            this.pdfSrc =
              location.protocol + "//" + res.sign_file_url.split("//")[1];
            this.pdf_file_url = res.sign_file_url;
          } else {
            this.pdfSrc =
              location.protocol + "//" + res.base_file_url.split("//")[1];
            this.pdf_file_url = res.base_file_url;
          }
          // console.log(this.pdfSrc);
          if (this.pdfSrc) {
            this.pdfSrc = pdf.createLoadingTask(this.pdfSrc);
            this.pdfSrc.promise.then((pdf) => {
              this.numPages = pdf.numPages;
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    copy() {
      var clipboard = new Clipboard("#copy", {
        text: () => {
          return this.pdf_file_url;
        },
      });
      clipboard.on("success", (e) => {
        this.$toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast("复制失败");
        // 释放内存
        clipboard.destroy();
      });
    },
    async pdfLoaded(i) {
      if (this.numPages !== i) {
        return;
      }
    },
  },
};
</script>
<style lang="less">
.seeContract {
  height: 100%;
  background: #f2f2f2;
  .seeContractNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
    .navRight {
      width: 20px;
      height: 20px;
      position: absolute;
      right: 16px;
      bottom: 10px;
    }
  }
  .contractTip {
    background-color: rgba(255, 219, 198, 0.9);
    padding: 10px 12px;
    font-size: 14px;
    color: #ff7e31;
    line-height: 20px;
  }
}
</style>